import { format } from "d3-format";
import React, { Component } from "react";
import PropTypes from "prop-types";

import displayValuesFor from "./displayValuesFor";
import GenericChartComponent from "../GenericChartComponent";

import ToolTipText from "./ToolTipText";
import ToolTipTSpanLabel from "./ToolTipTSpanLabel";
import { functor } from "../utils";

class VortexTooltip extends Component {
  constructor(props) {
    super(props);
    this.renderSVG = this.renderSVG.bind(this);
  }

  renderSVG(moreProps) {
    const {
      onClick,
      origin: originProp,
      className,
      fontFamily,
      fontSize,
      labelFill,
      textFill,
      displayFormat,
      yAccessor,
      options,
      appearance,
    } = this.props;

    const origin = functor(originProp);
    const {
      chartConfig: { width, height },
    } = moreProps;
    const [x, y] = origin(width, height);

    const currentItem = this.props.displayValuesFor(this.props, moreProps);
    const value = currentItem && yAccessor(currentItem);

    const plusVIValue =
      value && Number.isFinite(value.plusVI)
        ? displayFormat(value.plusVI)
        : "n/a";
    const minusVIValue =
      value && Number.isFinite(value.minusVI)
        ? displayFormat(value.minusVI)
        : "n/a";

    const period = options?.period;

    const plusColor = appearance?.strokePlusVI?.color || "#00FF00";
    const minusColor = appearance?.strokeMinusVI?.color || "#FF0000";

    return (
      <g
        className={className}
        transform={`translate(${x}, ${y})`}
        onClick={onClick}
        data-evo-id="tooltip-vortex"
      >
        <ToolTipText
          fontFamily={fontFamily}
          fontSize={fontSize}
          fill={textFill}
        >
          <ToolTipTSpanLabel fill={labelFill}>Vortex</ToolTipTSpanLabel>
          <ToolTipTSpanLabel
            fill={labelFill}
          >{` (${period ?? "?"})`}</ToolTipTSpanLabel>
          <ToolTipTSpanLabel fill={labelFill}> +VI: </ToolTipTSpanLabel>
          <tspan fill={plusColor}>{plusVIValue}</tspan>
          <ToolTipTSpanLabel fill={labelFill}> -VI: </ToolTipTSpanLabel>
          <tspan fill={minusColor}>{minusVIValue}</tspan>
        </ToolTipText>
      </g>
    );
  }

  render() {
    return (
      <GenericChartComponent
        clip={false}
        svgDraw={this.renderSVG}
        drawOn={["mousemove"]}
      />
    );
  }
}

VortexTooltip.propTypes = {
  origin: PropTypes.oneOfType([PropTypes.array, PropTypes.func]),
  className: PropTypes.string,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.number,
  labelFill: PropTypes.string,
  textFill: PropTypes.string,
  displayFormat: PropTypes.func,
  yAccessor: PropTypes.func.isRequired,
  options: PropTypes.object,
  appearance: PropTypes.object,
  displayValuesFor: PropTypes.func,
  onClick: PropTypes.func,
};

VortexTooltip.defaultProps = {
  origin: [0, 10],
  className: "react-stockcharts-tooltip react-stockcharts-vortex-tooltip",
  fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
  fontSize: 11,
  labelFill: "#4682B4",
  textFill: "#000000",
  displayFormat: format(".1f"),
  displayValuesFor,
  onClick: undefined,
};

export default VortexTooltip;
